// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"lq-z","slideIn":"mq-z"};